// extracted by mini-css-extract-plugin
export default {"mask":"mask_mask__JSBRv","slowFade":"mask_slowFade__0H-nq","maskImage":"mask_maskImage__FdnWT"};